import {
  Text,
} from '@chakra-ui/react';
import {
  useLengthVsVKT,
} from '@src/modules/performance/context/reports-api-hooks';
import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Journey Distribution - ONF Freight',
  content: [
    {
      title: 'Length vs VKT (ONF Freight)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The distribution of vehicle kilometres travelled and network length for the financial year, summarised by ONF Freight classifications.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Road Efficiency Group Te Ringa Maimoa has calculated this result.
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from the ONF classifications and traffic volumes recorded in AWM.
  </Text>,
    },
  ],
};

function RoadNetworkUseJourneyDistributionFreight() {
  const { data: lengthVsVktFreight, isLoading: isLoadingLengthFreight } = useLengthVsVKT('freight');
  const isLoading = isLoadingLengthFreight;

  // Freight Chart
  const lengthVsVktFreightData = [
    {
      name: 'Length %',
      type: 'bar',
      data: lengthVsVktFreight?.map((item) => ({
        x: item.Category,
        y: item.PercTotalKm > 0.5 ? item.PercTotalKm * -1 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Vehicle kilometres travelled %',
      type: 'bar',
      data: lengthVsVktFreight?.map((item) => ({
        x: item.Category,
        y: item.PercTotalVKT > 0.5 ? item.PercTotalVKT : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Journey Distribution - ONF Freight"
      isLoading={isLoading || !lengthVsVktFreight}
      informationSource={informationSource}
      lockYear={lengthVsVktFreight?.[0]?.LockYear}
    >
      <TornadoBarChart
        title="Length vs VKT (ONF Freight)"
        categories={[...new Set(lengthVsVktFreight?.map((item) => item.Category))]}
        series={lengthVsVktFreightData}
        dataLabelFormatter={(val) => {
          if (val === 0) {
            return '';
          }
          const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
          return labelFormatted;
        }}
        suffix="%"
      />
    </ReportSection>
  );
}

export default RoadNetworkUseJourneyDistributionFreight;
